var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 16,
    viewBox: "0 0 111 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41877 1.127C5.59595 3.0986 2.77166 5.09076 0.319921 7.29467C-0.0202304 7.601 -0.185152 8.09338 0.319921 8.38532C4.55635 10.837 8.17728 13.8417 13.0587 15.7012C14.3103 16.1782 15.4235 14.846 14.1748 14.37C9.46278 12.5742 5.97144 9.661 1.88079 7.29467C1.88079 7.65856 1.88079 8.02143 1.88079 8.38532C4.33253 6.1814 7.15829 4.18925 9.97964 2.21765C10.9883 1.5135 9.42597 0.422858 8.41877 1.127Z",
    fill: "#FAFBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.917764 9.12443C37.1972 9.17788 73.6731 11.6707 109.774 7.55473C110.94 7.42212 110.442 5.93672 109.289 6.0683C73.3632 10.1637 37.0178 7.63594 0.917764 7.58249C-0.263563 7.58146 -0.262342 9.1234 0.917764 9.12443Z",
    fill: "#FAFBF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWhite);
export default __webpack_public_path__ + "static/media/back_white.3ec4e53d0240246b4b447e9bb0de45a3.svg";
export { ForwardRef as ReactComponent };